import React from 'react';
import StoreLocatorSection from '../components/StoreLocatorSection';
import LiveRatesSection from '../components/LiveRatesSection';
import TrustSection from '../components/TrustSection';
import { MapPin } from 'lucide-react';

export default function StoreLocatorPage() {
  return (
    <div style={{ backgroundColor: '#f1f3f6', minHeight: '100vh', paddingBottom: '3rem' }}>
      
      {/* Page Header */}
      <div style={{
        background: 'linear-gradient(135deg, #0f172a 0%, #1e293b 100%)',
        color: '#ffffff',
        padding: '2.5rem 1rem 2rem',
        textAlign: 'center'
      }}>
        <div className="container" style={{ maxWidth: '1240px', margin: '0 auto' }}>
          <div style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '0.4rem',
            background: 'rgba(255, 255, 255, 0.12)',
            border: '1px solid rgba(255, 255, 255, 0.2)',
            borderRadius: '20px',
            padding: '0.25rem 0.8rem',
            fontSize: '0.74rem',
            fontWeight: 800,
            textTransform: 'uppercase',
            letterSpacing: '0.06em',
            marginBottom: '0.6rem'
          }}>
            <MapPin size={13} color="#60a5fa" />
            <span>Showroom Network</span>
          </div>
          <h1 style={{
            margin: '0 0 0.5rem',
            fontSize: 'clamp(1.6rem, 3vw, 2.4rem)',
            fontWeight: 800,
            fontFamily: "'Playfair Display', serif, Georgia"
          }}>
            Find Our Flagship Jewellery Showroom
          </h1>
          <p style={{
            margin: 0,
            fontSize: '0.92rem',
            color: '#94a3b8',
            maxWidth: '640px',
            margin: '0 auto'
          }}>
            Experience regal Indian jewellery in person with certified testing, bespoke bridal consultations, and insured vault pickups.
          </p>
        </div>
      </div>

      <StoreLocatorSection />

      <LiveRatesSection />

      <TrustSection />

    </div>
  );
}
